import { keyframes } from '@emotion/react';

import { THINKING_PARTS } from './thinkingParts';
import type { ThinkingStyleConfig } from './types';

const gradientAnimation = keyframes`
  from {
    background-position: 100% 0;
  }
  to {
    background-position: -100% 0;
  }
`;

export const THINKING_STYLE_CONFIG: ThinkingStyleConfig = {
  parts: THINKING_PARTS,
  baseStyle: (props) => {
    const separatorDividerColor = props.theme.colors.separator.divider;
    const featureSecondaryColor = props.theme.colors.feature.secondary;

    return {
      container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        gap: 0,
      },
      label: {
        fontSize: 'sm',
        lineHeight: 'sm',
        p: 0,
        m: 0,

        width: 'max-content',

        // Style properties, including thinking animation
        color: 'feature.secondary',
        '&[data-thinking=true]': {
          bgGradient: `radial(circle at 50% 12.5%, ${separatorDividerColor}, ${featureSecondaryColor} 37.5%)`,
          bgClip: 'text',
          backgroundSize: '200% auto',
          animation: `${gradientAnimation} 0.875s linear infinite`,
        },
      },
      expandButton: {
        // Flex properties
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        alignSelf: 'flex-start',
        width: 'max-content',
        gap: '0.125rem',

        // Interaction properties
        cursor: 'pointer',
        '&[data-can-expand=false]': {
          cursor: 'not-allowed',
        },
      },
      expandIndicator: {
        height: '0.875rem',
        width: '0.875rem',
        transitionProperty: 'transform',
        transitionDuration: 'fast',
        color: 'feature.secondary',
        '&[data-expanded=true]': {
          transform: 'rotate(90deg)',
        },

        '&[data-can-expand=false]': {
          color: 'interaction.disabled',
        },
      },
      expandedContent: {
        alignSelf: 'stretch',
        marginTop: 0.5,
        py: 0.5,
        paddingLeft: 1.5,
        borderLeft: '1px solid',
        borderColor: 'separator.divider',
      },
    };
  },
  defaultProps: {},
};
